export const PAGES = {
  GaragePurchased: 'my-vehicles',
  GarageFavorites: 'my-favorites',
  VehicleDetails: (id) => `vehicle/${id}`,
  Inventory: 'inventory',
  RecommendAFriend: 'recommendfriend',
  RecommendAFriendHistory: 'recommendfriend/referrals',
  RecommendAFriendReferral: 'recommendfriend/referral',
  RecommendAFriendAdded: 'recommendfriend/referral-added',
  RecommendAFriendMessagePreview: 'recommendfriend/preview',
  RecommendAFriendWhatFriendsSee: 'recommendfriend/what-friends-see',
  ReferralHowItWorks: 'how-it-works',
  DeletedDealer: 'deleted/dealer',
  DeletedSalesperson: 'deleted/salesperson',
  Reassigned: 'reassigned',
  TermAndConditions: 'terms',
  PrivacyPolicy: 'policy'
}



// WEBPACK FOOTER //
// ./scripts/src/shared/routes.constants.js